"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addressMapLink = void 0;
const addressMapLink = (address) => {
    return `https://www.google.com/maps/search/?api=1&query=${encodeURI(address)}`;
};
exports.addressMapLink = addressMapLink;
